import { render, staticRenderFns } from "./companyhistorydetails.vue?vue&type=template&id=e4b6ca08&scoped=true&"
import script from "./companyhistorydetails.vue?vue&type=script&lang=js&"
export * from "./companyhistorydetails.vue?vue&type=script&lang=js&"
import style0 from "./companyhistorydetails.vue?vue&type=style&index=0&id=e4b6ca08&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4b6ca08",
  null
  
)

export default component.exports